export default __webpack_public_path__ + "static/media/iphone_mockup3.15104b26.png";